import { ContentfulApi, getLocale } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from './queryKey'

export const usePracticesInformation = () => {
  const locale = getLocale()

  return useQuery([QUERY_KEY.PRACTICE_RECOMMENDATION], () =>
    ContentfulApi.requestPracticesInfo(locale)
  )
}
